<div class="app-footer">
  <section class="top-footer">
    <div class="content-wrapper">
      <ul>
        <li>
          <a
            (click)="goToRoutePlanner(urls.routePlanner)"
            (keyup.enter)="goToRoutePlanner(urls.routePlanner)"
            tabindex="0"
            >Route planner</a
          >
        </li>
        <li>
          <a
            (click)="goToRoutePlanner(urls.trafficNews)"
            (keyup.enter)="goToRoutePlanner(urls.trafficNews)"
            tabindex="0"
            >Traffic news</a
          >
        </li>
        <li>
          <a (click)="goToRoutePlanner(urls.maps)" (keyup.enter)="goToRoutePlanner(urls.maps)" tabindex="0"
            >Maps & AA Hotels</a
          >
        </li>
        <li><a href="http://www.theaa.com/driving/mileage-calculator.jsp">Mileage calculator</a></li>
        <li><a href="https://www.theaa.com/privacy-notice">Privacy policy</a></li>
        <li><a href="https://www.theaa.com/help-support/privacy">Privacy hub</a></li>
        <li><a href="https://www.theaa.com/cookie-policy">Cookies</a></li>
      </ul>
    </div>
  </section>
  <section class="middle-footer clear">
    <div class="content-wrapper">
      <div class="pull-left">
        <p></p>
      </div>
      <div class="pull-right mbl_left">
        <p>
          &copy;
          <span class="copyright_name"> Automobile Association Developments Ltd. </span>
          <span class="copyright_year"> 2026 </span>
        </p>
      </div>
    </div>
  </section>
  <section class="bottom-footer clear">
    <div class="content-wrapper">
      <div class="wrapper">
        <div class="col">
          <ul>
            <li><a href="https://www.theaa.com/breakdown-cover/">uk breakdown</a></li>
            <li><a href="https://www.theaa.com/breakdown-cover/european/">european breakdown</a></li>
            <li><a href="https://www.theaa.com/breakdown-cover/motorbikes">motorbike breakdown</a></li>
            <li>
              <a href="https://www.theaa.com/breakdown-cover/advice/what-to-do-if-you-break-down">report a breakdown</a>
            </li>
          </ul>
        </div>
        <div class="col">
          <ul>
            <li><a href="https://www.theaa.com/insurance/">insurance</a></li>
            <li><a href="https://www.theaa.com/car-insurance/">car insurance</a></li>
            <li><a href="https://www.theaa.com/home-insurance/">home insurance</a></li>
            <li><a href="https://www.theaa.com/travel-insurance/">travel insurance</a></li>
          </ul>
        </div>
        <div class="col">
          <ul>
            <li><a href="http://www.theaa.com/finance/">financial services</a></li>
            <li><a href="http://www.theaa.com/loans/">loans</a></li>
            <li><a href="http://www.theaa.com/savings-accounts">savings</a></li>
            <li><a href="https://www.theaa.com/cars/finance">car finance</a></li>
          </ul>
        </div>
        <div class="col">
          <ul>
            <li><a href="https://www.theaa.com/driving-advice">driving</a></li>
            <li><a href="https://www.theaa.com/driving-school/driving-lessons">driving lessons</a></li>
            <li><a href="https://www.theaa.com/driving-advice">motoring advice</a></li>
            <li><a href="http://www.theaa.com/vehicle-check">car data checks</a></li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</div>
